import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Ticket } from "lucide-react";

interface GwParticipantsProps {
  usernames: string[];
  boosts?: Record<string, number>;
  keyword: string;
}

const GwParticipants: React.FC<GwParticipantsProps> = ({
  usernames,
  boosts = {},
  keyword,
}) => {
  const [participantList, setParticipantList] = useState<string[]>([]);

  useEffect(() => {
    setParticipantList(usernames);
  }, [usernames]);

  return (
    <div className="participants-container p-4">
      <p className="uppercase text-center font-bold">
        TYPE IN CHAT:{" "}
        <b className="px-2 py-1 bg-gray-200 rounded text-black">{keyword}</b>
      </p>
      <div className="flex flex-col gap-1 text-center">
        <AnimatePresence mode="popLayout">
          {[...participantList]
            .reverse()
            .slice(0, 5)
            .map((username, index) => (
              <motion.p
                key={`${username}-${participantList.length - index}`}
                initial={{ opacity: 0, x: -50, scale: 0.8 }}
                animate={{ opacity: 1, x: 0, scale: 1 }}
                exit={{ opacity: 0, x: 50, scale: 0.8 }}
                transition={{
                  type: "spring",
                  stiffness: 500,
                  damping: 30,
                  mass: 1,
                }}
                layout
                className="px-1 uppercase font-bold py-1 bg-primary/10 rounded text-sm text-primary truncate flex items-center justify-center gap-1.5"
              >
                <span className="truncate">{username}</span>
                {!!boosts[username] && (
                  <span className="shrink-0 flex items-center gap-0.5 px-1.5 py-0.5 rounded-full bg-yellow-500/20 border border-yellow-500/50 text-yellow-400 text-xs font-bold">
                    <Ticket className="w-3 h-3" strokeWidth={2.5} />
                    {boosts[username]}
                  </span>
                )}
              </motion.p>
            ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default GwParticipants;
